import {
  STATUS_APPROVED,
  STATUS_DENIED,
  STATUS_NEEDS_INFO,
  PROCESS_REQUEST_HAND_SHIPMENT_FIELD,
  ARTYPE_NONSTOCKEDSSD,
} from '../../../../constants/ApprovalRequestConstants'
import {
  PROCESS_BUTTON_APPROVAL_REQUEST_DENIED_MESSAGE,
  PROCESS_BUTTON_APPROVAL_REQUEST_NEEDS_INFO_MESSAGE,
  PROCESS_BUTTON_APPROVAL_REQUEST_APPROVED_MESSAGE,
} from '../../../../constants/MessageConstants'
import { startProcessingApprovalRequest } from '../../../../actions/approvalRequests'
import {
  selectSelectedApprovalRequest,
  selectApprovalRequestType,
} from '../../../../selectors/approvalRequests'

const mapStateToProps = (state, ownProps) => {
  const {
    etsApprovalStatus: status,
    comments,
    [PROCESS_REQUEST_HAND_SHIPMENT_FIELD]: handshipped,
    reprocessApprovedInd = false,
  } = selectSelectedApprovalRequest(state)

  return {
    status,
    comments,
    handshipped,
    reprocessApprovedInd,
    arType: selectApprovalRequestType(state),
  }
}

const messageStyles = { fontStyle: 'italic', marginBottom: 0 }

const ClosedApprovalRequestMessaging = ({ message, comments, handshipped = false }) => (
  <>
    <p style={messageStyles}>{message}</p>
    {comments && <p style={messageStyles}>With comment: {comments}</p>}
    {handshipped && <p style={messageStyles}>Handshipment</p>}
  </>
)

ClosedApprovalRequestMessaging.displayName = 'ClosedApprovalRequestMessaging'

const ProcessButton = ({
  status,
  comments,
  handshipped,
  arType,
  reprocessApprovedInd,
  startProcessingApprovalRequest,
}) => {
  if (status === STATUS_DENIED) {
    return (
      <ClosedApprovalRequestMessaging
        message={PROCESS_BUTTON_APPROVAL_REQUEST_DENIED_MESSAGE}
        comments={comments}
      />
    )
  }

  if (arType !== ARTYPE_NONSTOCKEDSSD && status === STATUS_NEEDS_INFO) {
    return (
      <ClosedApprovalRequestMessaging
        message={PROCESS_BUTTON_APPROVAL_REQUEST_NEEDS_INFO_MESSAGE}
        comments={comments}
      />
    )
  }

  if (arType !== ARTYPE_NONSTOCKEDSSD && status === STATUS_APPROVED) {
    return (
      <ClosedApprovalRequestMessaging
        message={PROCESS_BUTTON_APPROVAL_REQUEST_APPROVED_MESSAGE}
        comments={comments}
        handshipped={handshipped}
      />
    )
  }

  return (
    <button
      type="button"
      className="btn btn-sm btn-primary"
      onClick={() => startProcessingApprovalRequest()}
      autoFocus
    >
      {arType === ARTYPE_NONSTOCKEDSSD &&
      (status === STATUS_APPROVED || (status === STATUS_NEEDS_INFO && reprocessApprovedInd))
        ? 'Re-process'
        : 'Process'}
    </button>
  )
}

ProcessButton.displayName = 'ProcessButton'

export default connect(mapStateToProps, { startProcessingApprovalRequest })(ProcessButton)
